export const cacheKey = 'makanify:subdomain';

export const bannedMakanifySites = ['www', 'mail', 'admin', 'auth', 'api'];

export const LeadSource = 'website';